module.exports = __webpack_public_path__ + "static/img/背景透過PNG形式04.882b24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/背景透過PNG形式04.png
// module id = Cxd3
// module chunks = 1